import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import _ from 'lodash';

class EmployeeTableSelectorState {
  store = new DomainStore();
  agent;
  onChange;

  includedEmployees = [];

  highlightedIncludedEmployeeIds = [];
  highlightedAvailableEmployeeIds = [];
  errorMessage;

  interactiveContextState = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      agent: false,
      onChange: false
    });
  }

  receiveProps({onChange, includedEmployees, errorMessage}) {
    this.onChange = onChange;
    this.includedEmployees = includedEmployees || [];
    this.errorMessage = errorMessage;
  }

  setInteractiveAgent(agent) {
    this.agent = agent;
  }

  updateInteractiveContextState(interactiveContextState) {
    this.interactiveContextState = interactiveContextState;
  }

  addEmployees() {
    this.includedEmployees = _.union(this.includedEmployees, this.highlightedAvailableEmployees);

    this.highlightedIncludedEmployeeIds = this.highlightedAvailableEmployeeIds;
    this.highlightedAvailableEmployeeIds = [];

    this.onChange(this.uniqueIncludedEmployees);
  }

  removeEmployees() {
    this.includedEmployees = _.reject(this.includedEmployees, e => _.includes(this.highlightedIncludedEmployeeIds, e.id));

    this.highlightedAvailableEmployeeIds = this.highlightedIncludedEmployeeIds;
    this.highlightedIncludedEmployeeIds = [];

    this.onChange(this.uniqueIncludedEmployees);
  }

  addAllEmployees() {
    this.includedEmployees = _.union(this.includedEmployees, this.availableEmployees);

    this.highlightedAvailableEmployeeIds = [];

    this.onChange(this.uniqueIncludedEmployees);
  }

  removeAllEmployees() {
    this.includedEmployees = [];

    this.onChange(this.uniqueIncludedEmployees);
  }

  updateHighlightedAvailableEmployeeIds(selectedOptions) {
    this.highlightedAvailableEmployeeIds = selectedOptions.map(option => option.value);
  }

  updateHighlightedIncludedEmployeeIds(selectedOptions) {
    this.highlightedIncludedEmployeeIds = selectedOptions.map(option => option.value);
  }

  get filteredEmployees() {
    return this.interactiveContextState.data;
  }

  get availableEmployees() {
    return _.differenceBy(this.filteredEmployees, this.includedEmployees, 'id');
  }

  get filteredIncludedEmployees() {
    return _.filter(this.filteredEmployees, e => _.includes(this.includedEmployeeIds, e.id));
  }

  get highlightedAvailableEmployees() {
    return _.filter(this.filteredEmployees, e => _.includes(this.highlightedAvailableEmployeeIds, e.id));
  }

  get highlightedIncludedEmployees() {
    return _.filter(this.filteredEmployees, e => _.includes(this.highlightedIncludedEmployeeIds, e.id));
  }

  get availableEmployeeIds() {
    return _.map(this.availableEmployees, 'id');
  }

  get includedEmployeeIds() {
    return _.map(this.includedEmployees, 'id');
  }

  get uniqueIncludedEmployees() {
    return _.uniqBy(this.includedEmployees, 'id');
  }

  get canAddAll() {
    return this.availableEmployees.length > 0;
  }

  get canRemoveAll() {
    return this.filteredIncludedEmployees.length > 0;
  }

  get canAdd() {
    return this.highlightedAvailableEmployeeIds.length > 0;
  }

  get canRemove() {
    return this.highlightedIncludedEmployeeIds.length > 0;
  }

  get sortedAvailableEmployees() {
    return _.orderBy(this.availableEmployees, 'name');
  }

  get sortedFilteredIncludedEmployees() {
    return _.orderBy(this.filteredIncludedEmployees, 'name');
  }
}

export default EmployeeTableSelectorState;
